import { parseISO, differenceInMonths } from 'date-fns'

/**
 * @param {number} monthNumber
 * @return {string}
 */
export function readableExperienceFromMonthNumber(monthNumber) {
  if (monthNumber < 12) {
    return monthNumber + ' mois'
  }

  let years = Math.floor(monthNumber/12);
  let months = monthNumber % 12;

  let strDuration = years + ' ' + (years === 1 ? 'an' : 'ans');

  if (months > 0) {
    strDuration +=  (' et ' + months + ' mois');
  }

  return strDuration;
}

export function calculateTotalExperience(experiences) {
  if (!Array.isArray(experiences) || experiences.length === 0) {
    return {
      years: 0,
      months: 0,
      label: 'Aucune'
    }
  }

  let totalMonths = 0

  experiences.forEach(exp => {
    const start = parseISO(exp.start)
    const end = exp.end ? parseISO(exp.end) : new Date()
    const months = differenceInMonths(end, start) + 1
    
    totalMonths += months
  })

  const years = Math.floor(totalMonths / 12)
  const months = totalMonths % 12

  let label = ''
  if (years > 0 && months > 0) {
    label = `${years} an${years > 1 ? 's' : ''} et ${months} mois`
  } else if (years > 0) {
    label = `${years} an${years > 1 ? 's' : ''}`
  } else {
    label = `${months} mois`
  }

  return { years, months, label }
}

export function prepareFreelanceBeforeSubmit(freelance) {
  return {
    ...freelance,
    agent: freelance.agent ? freelance.agent.id : null,
  }
}
